import React from 'react';
import { Box, Stack, Typography } from "@mui/material";
import doktorlogo from '../../../images/doktorlogo.png';
import doktorBlueLogo from "../../../assets/doktorConnect/doktor_connect_blue_logo .png"
export const DoktorFooter = () => {
    return (
        <Stack
            sx={ {
                marginTop: 2,
                width: '100%',
                alignItems: 'center'
            } }
        >
            {/* Main Logo Container */ }
            <Box
                sx={ {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                } }
            >
                <Box
                    component="img"
                    src={ doktorBlueLogo}
                    alt="doktor-logo"
                    sx={ {
                        width: '160px',
                        height: 'auto'
                    } }
                />
            </Box>

            {/* Powered By Section */ }
            <Stack
                sx={ {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                } }
            >
                <Typography
                    sx={ {
                        fontSize: '10px',
                        fontWeight: 500,
                        lineHeight: '15px',
                        color: '#000',
                        paddingLeft: '5px',
                        textAlign: 'center'
                    } }
                >
                    This health assessment is powered by
                </Typography>
                <Box
                    component="img"
                    src="/smlogo.png"
                    alt="smlogo"
                    sx={ {
                        width: '54px',
                        height: '54px'
                    } }
                />
            </Stack>

            {/* Product Image */ }
            {/* <Box>
                <Box
                    component="img"
                    src="/product.png"
                    alt="product"
                />
            </Box> */}
        </Stack>
    );
};